export default __webpack_public_path__ + "static/media/asc.91d5f050.svg";